function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useRef } from 'react';
import { useUpdate, useRefCallback } from '@okee-uikit/react-hooks';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { RimlessInput } from '../../util/RimlessInput';
import { Trigger, useTrigger } from '../../../hooks/popper';
import { useOptionUpdate, useSelect } from '../../../hooks/select';
export function SelectRimlessInput(props) {
  var locale = useLocale('select.placeholder');
  var _props$alignType = props.alignType,
      alignType = _props$alignType === void 0 ? 'left' : _props$alignType,
      triggerId = props.triggerId,
      useTag = props.useTag,
      show = props.show,
      clearable = props.clearable,
      onValueChange = props.onValueChange,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? locale : _props$placeholder,
      renderTrigger = props.renderTrigger;
  var select = useSelect();
  var extraProps = select.getExtraProps();
  var size = extraProps.size;
  var update = useUpdate();
  var triggerRef = useRef(null);

  var _useTrigger = useTrigger(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _construct(Trigger, args);
  }, {
    disabled: select.disabled || select.readonly
  }, triggerRef, 'click', triggerId),
      _useTrigger2 = _slicedToArray(_useTrigger, 1),
      clickTrigger = _useTrigger2[0];

  useEffect(function () {
    update();
  }, []);
  var clearHandle = useRefCallback(function () {
    return onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange('');
  });
  useOptionUpdate();
  var displayInfo = select.getDisplayInfo().map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      optionValue: item.value,
      value: item.id
    });
  });
  var cls = usePrefixCls('select-input-rimless');
  var tagCls = usePrefixCls('select-tag-rimless');
  var renderContent;

  if (renderTrigger) {
    renderContent = function renderContent() {
      if (renderTrigger) {
        var data = null;

        if (displayInfo.length) {
          data = _objectSpread(_objectSpread({}, displayInfo[0]), {}, {
            value: displayInfo[0].optionValue,
            id: displayInfo[0].value
          });
        }

        return renderTrigger(data, show);
      }
    };
  }

  var selectInputValue = displayInfo.reduce(function (labelArr, item) {
    labelArr.push(item.label);
    return labelArr;
  }, []).join('、');

  if (typeof window === 'undefined') {
    return null;
  }

  if (useTag) {
    return React.createElement("span", {
      className: tagCls,
      ref: triggerRef
    }, React.createElement(RimlessInput, {
      className: cls,
      "data-rc-id": "trigger___".concat(clickTrigger.getId()),
      size: size,
      alignType: alignType,
      value: selectInputValue,
      placeholder: placeholder,
      onClear: clearHandle,
      active: show,
      clearable: clearable,
      disabled: select.disabled,
      readonly: select.readonly,
      renderContent: renderContent,
      showNum: select.multiple && displayInfo.length ? displayInfo.length : undefined
    }));
  }

  return React.createElement(RimlessInput, {
    domRef: triggerRef,
    className: cls,
    "data-rc-id": "trigger___".concat(clickTrigger.getId()),
    size: size,
    alignType: alignType,
    value: selectInputValue,
    placeholder: placeholder,
    onClear: clearHandle,
    active: show,
    clearable: clearable,
    disabled: select.disabled,
    readonly: select.readonly,
    renderContent: renderContent,
    showNum: select.multiple && displayInfo.length ? displayInfo.length : undefined
  });
}